import JobCount from './JobCount'

export default JobCount
